export default __webpack_public_path__ + "static/media/contact.f51c250f.png";